import React from 'react';
import { Loader2 } from 'lucide-react';

export const CenteredLoadingState = ({
  label = 'Loading...',
  className = '',
  compact = false,
}) => (
  <div className={`flex items-center justify-center text-center ${compact ? 'py-6' : 'py-12'} ${className}`}>
    <div className="inline-flex items-center gap-3 rounded-md border border-slate-200 bg-white/95 px-4 py-3 text-sm font-medium text-slate-600 shadow-sm">
      <Loader2 className="h-4 w-4 animate-spin text-primary-600" />
      <span>{label}</span>
    </div>
  </div>
);

export const DataLoadingOverlay = ({
  active,
  label = 'Loading...',
  className = '',
}) => {
  if (!active) return null;

  return (
    <div
      className={`absolute inset-0 z-20 flex items-center justify-center bg-white/70 backdrop-blur-[1px] ${className}`}
      aria-live="polite"
      aria-busy="true"
    >
      <CenteredLoadingState label={label} compact />
    </div>
  );
};

export default CenteredLoadingState;
